import { IconVariants } from "@next-platform/client-common-spicy-ui";

export type SettingsItemProps = {
  title: string;
  subtitle?: string;
  type: GENERAL_SEETING_TYPE;
  value?: string | boolean;
  onChange?: () => Promise<void>;
  onOpen?: () => void;
  onClick?: () => void;
  options?: string[]; // for dropdown
  disabled?: boolean;
  icon: IconVariants;
  hidden?: boolean;
};

export enum GENERAL_SEETING_TYPE {
  TOGGLE = "toggle",
  MODAL = "modal",
  DROPDOWN = "dropdown",
  BUTTON = "button",
  TEXT = "text",
}
